{
  "invalidSelection": "Seçilen {selectedCount, plural, one {tarih} other {tarihler}} müsait değil."
}
